import { capitalizePerSpace, formatDate } from "helpers";
import { PatientInput } from "types";

const createPatientTable = (patient: PatientInput) => {
  const {
    type,
    firstName,
    middleName,
    lastName,
    birthday,
    gender,
    relation,
    notes,
    agreement,
    patientDataSharingAgreement,
    uploadPatientFiles,
    ...concerns
  } = patient;

  const formattedBirthay = birthday
    ? formatDate(birthday, { dateStyle: "medium" })
    : undefined;
  const joinedConcerns = Object.values(concerns).filter(Boolean).join(", ");
  
  return [
    ["Patient", `${firstName} ${lastName}`],
    ["Gender", gender || ""],
    ["Birthday", formattedBirthay || ""],
    ["Relation", relation || ""],
    ["Concerns", capitalizePerSpace(joinedConcerns)],
    ["Notes", notes || ""],
  ];
};

export default createPatientTable;
